import { useEffect, useState } from "react";
import { RefreshCw, Trash2, Phone } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function EnquiriesTab() {
  const [items, setItems] = useState(null);

  const load = () => api.get("/admin/enquiries").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
  }, []);

  if (!items) return <p className="font-mono text-xs uppercase tracking-[0.25em] text-subtle">Loading…</p>;

  const markRead = async (e) => {
    await api.patch(`/admin/enquiries/${e.id}`, { read: !e.read });
    load();
  };

  const del = async (e) => {
    if (!window.confirm(`Delete enquiry from ${e.name}?`)) return;
    await api.delete(`/admin/enquiries/${e.id}`);
    toast.success("Deleted.");
    load();
  };

  const unread = items.filter((e) => !e.read).length;

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <p className="text-sm text-mute">
          {items.length} enquiries · <span className="font-semibold text-srs">{unread} new</span>
        </p>
        <button data-testid="admin-enquiries-refresh" onClick={load} className="flex items-center gap-2 rounded-full border border-line bg-white px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-ink hover:border-srs">
          <RefreshCw size={13} /> Refresh
        </button>
      </div>

      <div className="overflow-x-auto rounded-3xl border border-line bg-white shadow-[0_14px_35px_-24px_rgba(13,13,17,0.18)]">
        <table className="w-full min-w-[760px] text-left text-sm" data-testid="admin-enquiry-table">
          <thead>
            <tr className="border-b border-line bg-bone font-mono text-[10px] uppercase tracking-[0.18em] text-subtle">
              <th className="px-4 py-3 font-medium">Received</th>
              <th className="px-4 py-3 font-medium">Name</th>
              <th className="px-4 py-3 font-medium">Phone</th>
              <th className="px-4 py-3 font-medium">Product</th>
              <th className="px-4 py-3 font-medium">Qty</th>
              <th className="px-4 py-3 font-medium">Location</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-line">
            {items.map((e, i) => (
              <tr key={e.id} className={e.read ? "text-mute" : "bg-srs-light/40 text-ink"} data-testid={`admin-enquiry-row-${i}`}>
                <td className="whitespace-nowrap px-4 py-3 font-mono text-xs">
                  {e.created_at ? new Date(e.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—"}
                </td>
                <td className="px-4 py-3 font-semibold">{e.name}</td>
                <td className="px-4 py-3">
                  <a href={`tel:+91${String(e.phone).replace(/\D/g, "").slice(-10)}`} className="flex items-center gap-1.5 text-srs hover:underline">
                    <Phone size={12} /> {e.phone}
                  </a>
                </td>
                <td className="px-4 py-3">{e.product_interest || "—"}</td>
                <td className="px-4 py-3">{e.quantity || "—"}</td>
                <td className="px-4 py-3">{e.location || "—"}</td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => markRead(e)}
                    data-testid={`admin-enquiry-read-${i}`}
                    className={`px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] ${e.read ? "border border-line text-subtle" : "bg-srs text-white"}`}
                  >
                    {e.read ? "Read" : "New"}
                  </button>
                </td>
                <td className="px-4 py-3">
                  <button onClick={() => del(e)} className="p-1.5 text-subtle hover:text-srs" aria-label="Delete enquiry"><Trash2 size={15} /></button>
                </td>
              </tr>
            ))}
            {!items.length && (
              <tr>
                <td colSpan={8} className="px-4 py-12 text-center text-sm text-subtle">
                  No enquiries yet. New submissions from the website form land here.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
